var map = {
	"./ITME_LOGO.png": 5774,
	"./Kaushal-Kumar.webp": 4473,
	"./agota-dregelyi-kiss.png": 2208,
	"./aman-jatain.jpeg": 5861,
	"./chuan-ming-liu.png": 2485,
	"./farooque-ahmad.jpg": 2599,
	"./hasan-koten.jpg": 5706,
	"./hema-chaudhary.webp": 162,
	"./jenq-haur-wang.jpg": 9392,
	"./kmu.png": 282,
	"./kriti.jpg": 8874,
	"./maria-jose-escalona.jpg": 9096,
	"./michael-bosnjak.png": 383,
	"./mn-hooda.jpg": 9670,
	"./pankaj-agarwal.jpg": 646,
	"./prabhakar-bhandari.webp": 8727,
	"./rupesh-kumar-tipu.webp": 8702,
	"./seema-raj.webp": 6160,
	"./shweta-bansal.jpg": 9551,
	"./usha-jagannathan.jpg": 6952
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7601;